
export default ["$sce","LocaleService","_","ConfigService", function i18n($sce, LocaleService,_,ConfigService) {

  function setText(elm, tag) {
    if (tag !== elm.html()) {
      elm.html($sce.getTrustedHtml(tag));
    }
  }

  function update(elm, string, optArgs) {
    if (LocaleService.isToken(string)) {
      setText(elm, LocaleService.getString(string, optArgs));
    }
    else {
      setText(elm, string);
    }
  }

  return {
    restrict: "A",
    link: function (scope, elm, attrs) {
      var hasObservers;

      attrs.$observe('i18n', function (newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          update(elm, newVal, hasObservers);
        }
      });

      angular.forEach(attrs.$attr, function (attr, normAttr) {
        if (new RegExp(ConfigService.get("i18n.observableAttrs",true), "gi").test(attr)) {


          attrs.$observe(normAttr, function (newVal, oldVal) {
            if ((newVal !== undefined && newVal != oldVal) || !hasObservers || !hasObservers[normAttr]) {
              hasObservers = hasObservers || {};
              hasObservers[normAttr] = attrs[normAttr] || "";
              update(elm, attrs.i18n, hasObservers);
            }
          });
        }
      });

    }
  };
}];



// WEBPACK FOOTER //
// ./src/ui/app/directives/i18n.js